import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Link,
} from '@mui/material'

type DonateDialogProps = {
  open: boolean
  onClose: () => void
}

const DonateDialog: React.FC<DonateDialogProps> = (props) => {
  return (
    <Dialog fullWidth maxWidth="xs" open={props.open} onClose={props.onClose}>
      <DialogTitle>Ny version av Tentamera</DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <Typography sx={{ mb: 2 }}>
            Det finns en ny version av Tentamera. Man behöver inget konto, all
            data sparas direkt i webbläsaren. Följ länken nedan:
          </Typography>
          <Link href="https://tentamera.netlify.app/">
            tentamera.netlify.app
          </Link>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button type="button" onClick={props.onClose}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DonateDialog
